<seds-modal>
  <div content>
    <div class="user-profile-change-confirmation__content">
      <div class="icon-modal-profile">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
          <path
            d="M39.9999 73.3337C33.4071 73.3337 26.9625 71.3787 21.4808 67.716C15.9992 64.0533 11.7268 58.8473 9.20387 52.7565C6.68095 46.6656 6.02084 39.9634 7.30701 33.4973C8.59318 27.0313 11.7679 21.0919 16.4296 16.4301C21.0914 11.7684 27.0308 8.59367 33.4968 7.3075C39.9629 6.02132 46.6651 6.68143 52.756 9.20436C58.8468 11.7273 64.0528 15.9997 67.7155 21.4813C71.3782 26.963 73.3332 33.4076 73.3332 40.0003C73.3235 48.8379 69.8085 57.3107 63.5594 63.5598C57.3102 69.809 48.8374 73.324 39.9999 73.3337ZM39.9999 36.667C39.1158 36.667 38.268 37.0182 37.6428 37.6433C37.0177 38.2684 36.6665 39.1163 36.6665 40.0003V53.3337C36.6665 54.2177 37.0177 55.0656 37.6428 55.6907C38.268 56.3158 39.1158 56.667 39.9999 56.667C40.8839 56.667 41.7318 56.3158 42.3569 55.6907C42.982 55.0656 43.3332 54.2177 43.3332 53.3337V40.0003C43.3332 39.1163 42.982 38.2684 42.3569 37.6433C41.7318 37.0182 40.8839 36.667 39.9999 36.667ZM36.6665 23.3337V30.0003H43.3332V23.3337H36.6665Z"
            fill="#687DB0" />
        </svg>
      </div>
      <p class="modal-title">{{ title }}</p>
      <p class="message">{{ content }}</p>
    </div>
  </div>   
   <div class="modal-footer" footer>
    <seds-flat-button title="Cancelar" (click)="closeModal()">
    </seds-flat-button>
    <seds-basic-button title="Alterar perfil" (click)="alterarPerfil()">
    </seds-basic-button>
  </div>
</seds-modal>